import { IconProps } from "../../types/utils";

const CalendarIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.0625 11.1875C16.4077 11.1875 16.6875 10.9077 16.6875 10.5625C16.6875 10.2173 16.4077 9.9375 16.0625 9.9375C15.7173 9.9375 15.4375 10.2173 15.4375 10.5625C15.4375 10.9077 15.7173 11.1875 16.0625 11.1875Z"
      fill={color || "#9CA7B7"}
    />
    <path
      d="M17.5 5.25H16.6875V4.625C16.6875 4.27981 16.4077 4 16.0625 4C15.7173 4 15.4375 4.27981 15.4375 4.625V5.25H12.5938V4.625C12.5938 4.27981 12.3139 4 11.9688 4C11.6236 4 11.3438 4.27981 11.3438 4.625V5.25H8.53125V4.625C8.53125 4.27981 8.25144 4 7.90625 4C7.56106 4 7.28125 4.27981 7.28125 4.625V5.25H6.5C5.1215 5.25 4 6.3715 4 7.75V17.5C4 18.8785 5.1215 20 6.5 20H11.2812C11.6264 20 11.9062 19.7202 11.9062 19.375C11.9062 19.0298 11.6264 18.75 11.2812 18.75H6.5C5.81075 18.75 5.25 18.1892 5.25 17.5V7.75C5.25 7.06075 5.81075 6.5 6.5 6.5H7.28125V7.125C7.28125 7.47019 7.56106 7.75 7.90625 7.75C8.25144 7.75 8.53125 7.47019 8.53125 7.125V6.5H11.3438V7.125C11.3438 7.47019 11.6236 7.75 11.9688 7.75C12.3139 7.75 12.5938 7.47019 12.5938 7.125V6.5H15.4375V7.125C15.4375 7.47019 15.7173 7.75 16.0625 7.75C16.4077 7.75 16.6875 7.47019 16.6875 7.125V6.5H17.5C18.1892 6.5 18.75 7.06075 18.75 7.75V11.3125C18.75 11.6577 19.0298 11.9375 19.375 11.9375C19.7202 11.9375 20 11.6577 20 11.3125V7.75C20 6.3715 18.8785 5.25 17.5 5.25Z"
      fill={color || "#9CA7B7"}
    />
    <path
      d="M16.2188 12.4375C14.1337 12.4375 12.4375 14.1337 12.4375 16.2188C12.4375 18.3038 14.1337 20 16.2188 20C18.3038 20 20 18.3038 20 16.2188C20 14.1337 18.3038 12.4375 16.2188 12.4375ZM16.2188 18.75C14.823 18.75 13.6875 17.6145 13.6875 16.2188C13.6875 14.823 14.823 13.6875 16.2188 13.6875C17.6145 13.6875 18.75 14.823 18.75 16.2188C18.75 17.6145 17.6145 18.75 16.2188 18.75Z"
      fill={color || "#9CA7B7"}
    />
    <path
      d="M17.125 15.5938H16.8438V14.9375C16.8438 14.5923 16.5639 14.3125 16.2188 14.3125C15.8736 14.3125 15.5938 14.5923 15.5938 14.9375V16.2188C15.5938 16.5639 15.8736 16.8438 16.2188 16.8438H17.125C17.4702 16.8438 17.75 16.5639 17.75 16.2188C17.75 15.8736 17.4702 15.5938 17.125 15.5938Z"
      fill={color || "#9CA7B7"}
    />
    <path
      d="M13.3438 11.1875C13.6889 11.1875 13.9688 10.9077 13.9688 10.5625C13.9688 10.2173 13.6889 9.9375 13.3438 9.9375C12.9986 9.9375 12.7188 10.2173 12.7188 10.5625C12.7188 10.9077 12.9986 11.1875 13.3438 11.1875Z"
      fill={color || "#9CA7B7"}
    />
    <path
      d="M10.625 13.9062C10.9702 13.9062 11.25 13.6264 11.25 13.2812C11.25 12.9361 10.9702 12.6562 10.625 12.6562C10.2798 12.6562 10 12.9361 10 13.2812C10 13.6264 10.2798 13.9062 10.625 13.9062Z"
      fill={color || "#9CA7B7"}
    />
    <path
      d="M7.90625 11.1875C8.25143 11.1875 8.53125 10.9077 8.53125 10.5625C8.53125 10.2173 8.25143 9.9375 7.90625 9.9375C7.56107 9.9375 7.28125 10.2173 7.28125 10.5625C7.28125 10.9077 7.56107 11.1875 7.90625 11.1875Z"
      fill={color || "#9CA7B7"}
    />
    <path
      d="M7.90625 13.9062C8.25143 13.9062 8.53125 13.6264 8.53125 13.2812C8.53125 12.9361 8.25143 12.6562 7.90625 12.6562C7.56107 12.6562 7.28125 12.9361 7.28125 13.2812C7.28125 13.6264 7.56107 13.9062 7.90625 13.9062Z"
      fill={color || "#9CA7B7"}
    />
    <path
      d="M7.90625 16.625C8.25143 16.625 8.53125 16.3452 8.53125 16C8.53125 15.6548 8.25143 15.375 7.90625 15.375C7.56107 15.375 7.28125 15.6548 7.28125 16C7.28125 16.3452 7.56107 16.625 7.90625 16.625Z"
      fill={color || "#9CA7B7"}
    />
    <path
      d="M10.625 16.625C10.9702 16.625 11.25 16.3452 11.25 16C11.25 15.6548 10.9702 15.375 10.625 15.375C10.2798 15.375 10 15.6548 10 16C10 16.3452 10.2798 16.625 10.625 16.625Z"
      fill={color || "#9CA7B7"}
    />
    <path
      d="M10.625 11.1875C10.9702 11.1875 11.25 10.9077 11.25 10.5625C11.25 10.2173 10.9702 9.9375 10.625 9.9375C10.2798 9.9375 10 10.2173 10 10.5625C10 10.9077 10.2798 11.1875 10.625 11.1875Z"
      fill={color || "#9CA7B7"}
    />
  </svg>
);

export default CalendarIcon;
